import StoredLayout from '../../layouts/StoredLayout'
import MaterialDesignIcons from './MaterialDesignIcons'
export default StoredLayout(MaterialDesignIcons)
